import * as React from 'react';
import type { SVGProps } from 'react';

const IconShareArrow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="22"
    height="17"
    viewBox="0 0 22 17"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M21.119 8.075 12.952 0v4.727c-3.193.506-6.657 2.608-8.86 4.95C1.124 12.596.157 15.892 0 16.136c3.551-2.832 7.79-4.405 12.952-4.827v4.841z"
    />
  </svg>
);

export default IconShareArrow;
